export default __webpack_public_path__ + "static/media/Rama-Regmi.6e288f34.jpg";